import { IconAdd } from '@consta/icons/IconAdd'
import { Button } from '@consta/uikit/Button'
import { Text } from '@consta/uikit/Text'
import { textProps } from '@core/core/helpers'
import type { Calculation, FormDataML } from '@core/core/types'
import type { FC } from 'react'

import css from './Calculation.css'
import { CalculationCard } from './CalculationCard'

type CalculationsProps = {
  formData: FormDataML
  addCalculation: () => void
  updateCalculation: (calc: Calculation) => void
  deleteCalculation: (id: number) => void
}
const CALC_MAX_COUNT = 30

export const Calculations: FC<CalculationsProps> = ({
  formData,
  addCalculation,
  updateCalculation,
  deleteCalculation,
}) => {
  return (
    <>
      <div className={css.container}>
        <Text {...textProps}>Расчеты</Text>
        <Button
          size="xs"
          view="secondary"
          onlyIcon={true}
          disabled={formData.calculations.length >= CALC_MAX_COUNT}
          iconLeft={IconAdd}
          onClick={addCalculation}
        />
      </div>
      <div className={css.calculations}>
        {formData.calculations.map(calc => (
          <CalculationCard
            key={calc.id}
            formData={formData}
            calculation={calc}
            type={formData.type}
            updateCalculation={updateCalculation}
            deleteCalculation={() => {
              deleteCalculation(calc.id)
            }}
          />
        ))}
      </div>
    </>
  )
}
